import { krakenApi } from "../config/http-common";
import deviceContextData from "../types/deviceContextData.type";
import otpData from "../types/otp.type";

class ChallengeService {
    initChallenge(data: otpData) {
        return krakenApi.post<otpData>("/enrolment/challengeRespond", data);
    }
    resendCode(data: deviceContextData,sessionId: string) {
        return krakenApi.post<deviceContextData>(`/enrollment/otc/resendOTP/${sessionId}`, data);
    }
}

export default new ChallengeService();